'use client';

import type { KeyTextField, LinkField, RichTextField } from '@prismicio/client';

import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import styles from './cTATextContent.module.scss';
import { Button } from '@/components';
import { useVisible } from '@/hooks';

interface CTATextContentProps {
  title: RichTextField;
  subtitle: KeyTextField;
  buttonText: KeyTextField;
  buttonLink: LinkField;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const CTATextContent = ({
  buttonLink,
  buttonText,
  subtitle,
  title,
}: CTATextContentProps) => {
  const [isVisible, id] = useVisible();

  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={styles.article} id={id}>
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={title} components={components} />
      </div>
      <p className={`${styles.subtitle} ${isVisibleStyles}`}>{subtitle}</p>
      <div className={`${styles.button_wrapper} ${isVisibleStyles}`}>
        <Button link={buttonLink} text={buttonText} variation="white" />
      </div>
    </article>
  );
};
